import { CircularProgress } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { connect, useSelector, shallowEqual, useDispatch } from 'react-redux'
import { fetchSurveyNavigationByCaseId, getCase, getIsCircleTermsAccepted, setEmailClick, setEmailClickByCaseId, setEmailClickByMessageId } from '../redux/actions'
import { nextSurveyMayBeEmptySelector, isCircleTermsAcceptedSelector, surveyNavigationSelector } from '../redux/selectors'
import history from '../utilties/history'
import { useLocation } from 'react-router'
import queryString from 'query-string'

const SurveyRedirect = ({ 
	match, 
	getNextSurvey, 
	nextSurvey, 
	loadSurveyNavigation, 
	surveyNavigation, 
	setEmailClickByMessageId ,
	setEmailClickByCaseId
}) => {
	const location = useLocation()

	useEffect(
		() => {
			if (match.params.patientId) {
				const values = queryString.parse(location.search)
				if(values.messageId) {
					setEmailClickByMessageId(values.messageId)
				} else if(values.patient && values.token) {
					setEmailClickByCaseId(match.params.caseId)
				}

				loadSurveyNavigation(match.params.caseId)
				getNextSurvey(match.params.patientId, match.params.caseId)
			}
		},
		[match.params.patientId, match.params.caseId]
	)

	useEffect(
		() => {
			if (nextSurvey && nextSurvey.caseId && nextSurvey.protocolId) {
				if(nextSurvey.instanceId && nextSurvey.surveyId) {
					history.push(`/survey/${nextSurvey.caseId}/${nextSurvey.protocolId}/${nextSurvey.instanceId}/${nextSurvey.surveyId}`)
				} else if(!surveyNavigation) {
					//Need to wait for surveyNavigation to load
					return
				} else if (surveyNavigation && surveyNavigation.isSuccessful && surveyNavigation.nextSurveyInstanceId) {
					history.push(`/survey/${surveyNavigation.nextCaseId}/${surveyNavigation.nextProtocolId}/${surveyNavigation.nextSurveyInstanceId}/${surveyNavigation.nextSurveyId}`)
				} else {
					history.push('/scores')
				}
			}
		},
		[nextSurvey, surveyNavigation]
	)

	return (<div style={{height: '100vh', backgroundColor: 'white'}}><CircularProgress style={{position: 'absolute', top: '50%', left: '50%'}} /></div>)
}

const mapStateToProps = (state) => ({
	nextSurvey: nextSurveyMayBeEmptySelector(state),
	surveyNavigation: surveyNavigationSelector(state)
})

const mapDispatchToProps = (dispatch) => ({
	getNextSurvey: (id, caseId) => dispatch(getCase(id, caseId)),
	loadSurveyNavigation: (caseId) => dispatch(fetchSurveyNavigationByCaseId(caseId, 1)),
	setEmailClickByMessageId: (messageId) => dispatch(setEmailClickByMessageId(messageId)),
	setEmailClickByCaseId: (caseId) => dispatch(setEmailClickByCaseId(caseId))
})

const enhance = connect(mapStateToProps, mapDispatchToProps)

export default enhance(SurveyRedirect)